import React, { Component, Fragment } from 'react'

import OrderTableRow from '../../components/OrderTableRow/'
import { TableHeader, HeaderItem } from './styles'

class OrderTable extends Component {

  render() {
    const {
      headers,
      items,
      data,
      loading,
      error
    } = this.props

    return (
      <Fragment>
        <TableHeader>
          {headers.map((header, index) => {
            return <HeaderItem key={index}> {header}</HeaderItem>
          })}
          <HeaderItem />
        </TableHeader>

        {items.map(item => {
          return (
            <OrderTableRow
              key={item.id}
              item={item}
              headers={headers}
              data={data}
              loading={loading}
              error={error}
            />
          )
        })}
      </Fragment>
    )
  }
}

export default OrderTable



// WEBPACK FOOTER //
// ./src/components/OrderTable/index.js